<template src="./Slider.html"></template>
<style src="./Slider.scss" lang="scss"></style>

<script>
	import Teaser from '@/components/Teaser/Teaser';

	const SLIDE_DIRECTIONS = {
		leftright: 'leftright',
		rightleft: 'rightleft',
		topbottom: 'topbottom',
		bottomtop: 'bottomtop',
		fade: 'fade'
	};

	const INDICATOR_POSITIONS = {
		top: 'top',
		bottom: 'bottom',
		left: 'left',
		right: 'right'
	};

	export default {
		data () {
			return {
				current: 0,
				slideTrack: null,
				slides: [],
				indicators: [],
				autoslide: '',
				indicatorsData: [],
				touchDetector: {
					startX: '',
					startY: '',
					endX: '',
					endY: ''
				}
			};
		},
		props: {
			elements: Array,
			slideDirection: {
				type: String,
				required: false,
				default: SLIDE_DIRECTIONS.leftright
			},
			indicatorPosition: {
				type: String,
				required: false,
				default: INDICATOR_POSITIONS.top
			},
			interval: {
				type: Number,
				required: false,
				default: 0
			},
			showArrows: {
				type: Boolean,
				required: false,
				default: true
			},
			showIndicators: {
				type: Boolean,
				required: false,
				default: true
			}
		},
		components: {
			'hp-teaser': Teaser
		},
		methods: {
			goPrev () {
				this.current === 0 ? (this.current = this.slides.length - 1) : this.current--;
				this.moveContentWrapper();
			},
			goNext () {
				this.current === this.slides.length - 1 ? (this.current = 0) : this.current++;
				this.moveContentWrapper();
			},
			goTo (ev) {
				this.current = ev.currentTarget.dataset.indicator !== undefined ? +ev.currentTarget.dataset.indicator : +ev.currentTarget.parentNode.dataset.indicator;
				this.moveContentWrapper();
			},
			rulerRightHandler (element, container, reference) {
				const ruler = Math.abs(container.offsetLeft) + reference.offsetWidth;
				const offsetRight = element.offsetLeft + element.offsetWidth - 1; // remove the overlapped 1px
				if (offsetRight > ruler) {
					container.style.left = reference.offsetWidth - offsetRight + 'px';
				}
			},
			rulerLeftHandler (element, container, reference) {
				if (Math.abs(container.offsetLeft) > element.offsetLeft) {
					container.style.left = 0 - element.offsetLeft + 'px';
				}
			},
			moveContentWrapper () {
				switch (this.slideDirection) {
					case SLIDE_DIRECTIONS.topbottom: {
						this.slideTrack.style.top = `-${this.current * this.slides[0].offsetHeight}px;`;
						break;
					}
					case SLIDE_DIRECTIONS.bottomtop: {
						this.slideTrack.style.top = `${this.current * this.slides[0].offsetHeight}px;`;
						break;
					}
					case SLIDE_DIRECTIONS.leftright: {
						this.slideTrack.style.left = `-${this.current * this.slides[0].offsetWidth}px;`;
						break;
					}
					case SLIDE_DIRECTIONS.rightleft: {
						this.slideTrack.style.left = `${this.current * this.slides[0].offsetWidth}px;`;
						break;
					}
					default: {
					}
				}
			},
			startSlide () {
				this.autoslide = setInterval(this.goNext, +this.interval);
			},
			swipeHandler (ev) {
				if (ev.type === 'touchstart') {
					this.touchDetector.startX = ev.touches[0].clientX;
				}
				if (ev.type === 'touchmove') {
					ev.preventDefault();
				}
				if (ev.type === 'touchend') {
					this.touchDetector.endX = ev.changedTouches[0].clientX;
					+this.touchDetector.startX < +this.touchDetector.endX ? this.goPrev(ev) : this.goNext(ev);
					this.touchDetector.startX = '';
					this.touchDetector.endX = '';
				}
			}
		},
		mounted () {
			this.$nextTick(() => {
				if (this.showIndicators) {
					if (this.elements) {
						this.indicatorsData = this.elements.map((element) => {
							return {
								text: element.article.header.label.text,
								img: element.article.header.label.img,
								href: element.link.href
							};
						});
					}
				}
			});

			this.$nextTick().then(() => {
				this.slideList = this.$el.querySelector('[data-wrapper]');
				this.slideTrack = this.$el.querySelector('[data-wrapper] > div');
				this.slides = this.$el.querySelectorAll('[data-wrapper] > div > [data-component]');
				this.indicators = this.$el.querySelectorAll('[data-part="indicators"] [data-indicator]');

				if (this.slides.item(this.current)) {
					this.slides.item(this.current).toggleAttribute('data-current', true);
				}

				if (!this.indicators.length) {
					// via timeout, because IE11 has no indicators rendered in the promise
					setTimeout(() => {
						this.indicators = this.$el.querySelectorAll('[data-part="indicators"] [data-indicator]');
						if (this.indicators.item(this.current)) {
							this.indicators.item(this.current).toggleAttribute('data-current', true);
						}
					}, 200);
				}

				if (this.slideDirection === SLIDE_DIRECTIONS.leftright) {
					this.slideTrack.style.width = this.slideList.offsetWidth * this.slides.length + 'px';
				}

				let touchDevice = window.getComputedStyle(document.documentElement).getPropertyValue('--screen-touchable') === 'true' || false;
				if (+this.interval) {
					this.startSlide();
					if (!touchDevice) {
						this.$el.addEventListener('mouseover', () => {
							clearInterval(this.autoslide);
						});
						this.$el.addEventListener('mouseout', () => {
							this.startSlide();
						});
					} else {
						// for touch event
						this.$el.addEventListener('touchstart', (ev) => {
							this.swipeHandler(ev);
							clearInterval(this.autoslide);
						});
						this.$el.addEventListener('touchend', (ev) => {
							this.swipeHandler(ev);
							this.startSlide();
						});
					}
				}
			});
		},
		watch: {
			current: function () {
				if (this.slideDirection === SLIDE_DIRECTIONS.leftright) {
					this.slideTrack.style.left = -this.slideList.offsetWidth * this.current + 'px';
				}

				const target = this.indicators.item(this.current);
				// Make movement of the indicators
				const elIndicators = (target && target.parentNode) || null;
				if (!elIndicators) {
					return elIndicators;
				}
				// Check whether target is in visual zone
				this.rulerRightHandler(target, elIndicators, this.$el);
				this.rulerLeftHandler(target, elIndicators, this.$el);
				// If target has next sibling, check whether target.nextSibling is in visual zone
				target.nextSibling && target.offsetWidth + target.nextSibling.offsetWidth < this.$el.offsetWidth && this.rulerRightHandler(target.nextSibling, elIndicators, this.$el);
				// If target has previous sibling, check whether target.nextSibling is in visual zone
				target.previousSibling && target.offsetWidth + target.previousSibling.offsetWidth < this.$el.offsetWidth && this.rulerLeftHandler(target.previousSibling, elIndicators, this.$el);

				this.slides.forEach((item, index) => item.toggleAttribute('data-current', index === this.current));
				this.indicators.forEach((item, index) => item.toggleAttribute('data-current', index === this.current));
			}
		},
		beforeDestroy () {
			clearInterval(this.autoslide);
		}
	};
</script>
